import { SvgIcon, SvgIconProps } from '@mui/material';

const ShopbySyncMenuIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      sx={{
        // 기본 opacity는 0.4
        color: '#FA2829',
        opacity: 0.4,
        transition: 'opacity 0.2s ease',
        // 부모에 .active 클래스가 있을 경우 opacity: 1
        '.active &': {
          opacity: 1,
        },
      }}
      {...props}
    >
      <path d="M3 1H21.1739V19.1739H8.10145L3 23V1Z" fill="currentColor" />
    </SvgIcon>
  );
};

export default ShopbySyncMenuIcon;
